const defaultRoutes: { [key: string]: string } = {
  ViewMonitoringDashboards: "/landing",
  ViewEmployeeProductivity: "/time-util",
  Configuration: "/Application-License",
};

export default defaultRoutes;
